import { ComponentProps } from 'react';

import clsx from 'clsx';

type SectionHeaderProps = ComponentProps<'header'> & {
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  title?: string;
};

export function SectionHeader(props: SectionHeaderProps) {
  const { element = 'h2', title, children, className } = props;

  const Element = element;

  return (
    <header className={clsx('flex justify-between flex-wrap mb-4 gap-4', className)}>
      <Element className="title">{title}</Element>
      {children}
    </header>
  );
}
